import {_delete, _get, _post, _put} from "@api/doinsport/services/httpService";

const URI = 'clubs/playgrounds/timetables/blocks/prices/variations';

export const postBlockPriceVariation = (blockPriceVariation) => _post(URI, blockPriceVariation);

export const putBlockPriceVariation = (blockPriceVariation) => _put(URI + '/' + blockPriceVariation.id, blockPriceVariation);

export const deleteBlockPriceVariation = (id) => _delete(URI + '/' + id);
